export default function Loading() {
  return (
    <div className="loading">
      <div className="loading-text">LOADING</div>
    </div>
  );
}
